import { Button, InputJson } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import DepartmentHeadFormPresenter from "./DepartmentHeadFormPresenter";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import Hierarchy from "../../../../components/common/Hierarchy";
import InputFactory from "../../../../components/InputFactory";
import ProgressDialog from "../../../../components/common/ProgressDialog";

class DepartmentHeadForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      employees: [],
      showProgressModal: false,
      saveProgress: 0,
      savedCount: 0,
      totalCount: 0,
      progressMessage: "Updating employees...",
    };
    this.presenter = new DepartmentHeadFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  // Add this method to DepartmentHeadForm
  componentDidUpdate(prevProps, prevState) {
    const object = this.state.object;
    const prevObject = prevState.object;

    // Trigger only once when object first loads (edit mode)
    if (object && !prevObject) {
      const order = [
        "region",
        "office",
        "division",
        "section",
        "unit",
        "cluster",
      ];
      const hierarchy = {};
      this.setState({ selectedSupervisor: object?.selectedSupervisor });

      order.forEach((field) => {
        if (object[field]) hierarchy[field] = object[field];
        else hierarchy[field] = "";
      });

      this.handleObjectChange(hierarchy);
    }
  }

  getCollectionName() {
    return "department_head";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  async handleObjectChange(hierarchy) {
    const order = [
      "region",
      "office",
      "division",
      "section",
      "unit",
      "cluster",
    ];
    const lastKey = order.filter((field) => hierarchy[field] !== "").at(-1);
    const lastValidField = lastKey ? { [lastKey]: hierarchy[lastKey] } : {};

    try {
      const filteredEmp = await findObjectUseCase().execute("employees", {
        where: lastValidField,
        keys: ["id"],
      });
      // console.log("FILTER: ", filteredEmp);
      // console.log("hierarchy: ", hierarchy);
      this.setState({ ...hierarchy, filteredEmp });
    } catch (e) {
      console.error(e.message || e);
    }
  }

  handleHierarchyChange(field, value) {
    this.setState({ [field]: value });
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Update ";
    return (
      <>
        <div className="overflow-auto" style={{ height: "100vh" }}>
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-5 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.save();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <label>
                          <b>Select Organization Structure</b>
                        </label>
                        <Hierarchy
                          className="col-lg-4 ps-1 pe-1 mb-2"
                          required
                          object={object}
                          handleObjectChange={this.handleObjectChange.bind(
                            this,
                          )}
                        />
                        <label>
                          <b>Select the assigned supervisor.</b>
                        </label>
                        <InputFactory
                          type="Pointer"
                          target="employees"
                          object={object}
                          placeholder="Supervisor"
                          required={true}
                          field="selectedSupervisor"
                          onChange={(value, field) =>
                            this.handleHierarchyChange(field, value)
                          }
                        />
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <Button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                      progress={this.state.progress}
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </Button>
                    <Button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                      progress={this.state.progress}
                    >
                      GO BACK
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {this.state.showProgressModal && (
          <ProgressDialog
            saveProgress={this.state.saveProgress}
            savedCount={this.state.savedCount}
            totalCount={this.state.totalCount}
            title="Updating Employees"
            processingMessage={this.state.progressMessage}
            successMessage="Employee records updated successfully!"
            countLabel="employees"
          />
        )}
      </>
    );
  }
}

export default withRouter(DepartmentHeadForm);
